
import { Loading } from 'element-ui';
var globalMask = null
//打开遮罩层
const show = () => {
    globalMask = Loading.service({
        lock: true,
        text: 'Loading',               //提示文字
        spinner: "el-icon-loading",        //图标
        background: 'rgba(0, 0, 0, 0.7)',  //遮罩层背景颜色
    })
}
//关闭遮罩层
const close = () => {
    if (globalMask) {
        globalMask.close()
    }
}

export default {
    show,
    close
}